<template>
  <div class="modal fade" id="RationReminderModal" ref="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-width-custom">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" data-bs-dismiss="modal">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal-premium">
          <div class="title-modal">
            <i class="ti ti-bell font-30 orange-color mb-3"></i>
            <h3>Configurer le rappel</h3>
            <p v-if="ration && ration.animal" class="text-muted mt-2">Pour {{ ration.animal.name }}</p>
          </div>

          <form class="mt-4 modal-form-premium" @submit.prevent="save">
            <div class="form-container-premium">
              <div class="form-row-premium mb-4">
                <div class="input-form input-form-half">
                  <label class="label-control">Type de rappel à J-7</label>
                  <div class="d-flex align-items-center gap-3 mt-2">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="modalReminderEmail"
                        value="email"
                        v-model="form.reminderJ7Type"
                      />
                      <label class="form-check-label" for="modalReminderEmail"> Email </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="modalReminderSMS"
                        value="sms"
                        v-model="form.reminderJ7Type"
                      />
                      <label class="form-check-label" for="modalReminderSMS"> SMS </label>
                    </div>
                  </div>
                </div>

                <div class="input-form input-form-half">
                  <label class="label-control">Date de mise en place*</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="form.applicationStartDate"
                    :class="{ 'is-invalid': errors.applicationStartDate }"
                    required
                  />
                  <div v-if="errors.applicationStartDate" class="invalid-feedback">
                    {{ errors.applicationStartDate }}
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center gap-3 mt-5">
                <button type="button" class="btn btn-outline-orange btn-premium" data-bs-dismiss="modal">
                  Annuler
                </button>
                <button type="submit" class="btn btn-orange btn-premium" :disabled="loading">
                  <span v-if="loading"> <i class="ti ti-loader"></i> Enregistrement... </span>
                  <span v-else>Valider</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { calculRationService } from "@/api/services/calculRationService";
  import { Modal } from "bootstrap";

  export default {
    name: "RationReminderModal",
    data() {
      return {
        ration: null,
        form: {
          reminderJ7Type: [],
          applicationStartDate: "",
        },
        errors: {},
        loading: false,
        modalInstance: null,
      };
    },
    mounted() {
      this.modalInstance = new Modal(this.$refs.modal);
      this.$refs.modal.addEventListener("hidden.bs.modal", this.resetForm);
    },
    beforeUnmount() {
      if (this.$refs.modal) {
        this.$refs.modal.removeEventListener("hidden.bs.modal", this.resetForm);
      }
    },
    methods: {
      open(ration) {
        this.ration = ration;
        this.initForm();
        this.modalInstance.show();
      },
      close() {
        this.modalInstance.hide();
      },
      initForm() {
        this.errors = {};
        if (this.ration) {
          if (Array.isArray(this.ration.reminderJ7Type)) {
            this.form.reminderJ7Type = [...this.ration.reminderJ7Type];
          } else if (typeof this.ration.reminderJ7Type === "string") {
            this.form.reminderJ7Type = [this.ration.reminderJ7Type];
          } else {
            this.form.reminderJ7Type = [];
          }

          if (this.ration.applicationStartDate) {
            this.form.applicationStartDate = this.formatDate(this.ration.applicationStartDate);
          } else {
            this.form.applicationStartDate = "";
          }
        } else {
          this.resetForm();
        }
      },
      resetForm() {
        this.form = {
          reminderJ7Type: [],
          applicationStartDate: "",
        };
        this.errors = {};
        this.loading = false;
      },
      formatDate(dateString) {
        if (!dateString) return "";
        return dateString.split(" ")[0].split("T")[0];
      },
      validate() {
        this.errors = {};
        let isValid = true;

        if (this.form.reminderJ7Type.length > 0 && !this.form.applicationStartDate) {
          this.errors.applicationStartDate = "La date est obligatoire si un rappel est sélectionné";
          isValid = false;
        }

        return isValid;
      },
      async save() {
        if (!this.validate()) return;

        this.loading = true;
        try {
          const data = {
            reminderJ7Type: this.form.reminderJ7Type,
            applicationStartDate: this.form.applicationStartDate,
          };

          await calculRationService.updateRation(this.ration.id, data);

          this.$emit("saved");
          this.close();
        } catch (error) {
          console.error("Erreur lors de la mise à jour du rappel:", error);
          alert("Une erreur est survenue lors de l'enregistrement.");
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .modal-width-custom {
    max-width: 600px !important;
    margin: 0 auto !important;
  }

  .padd-modal-premium {
    padding: 25px 35px 35px !important;
  }

  .modal-form-premium {
    max-width: 100%;
  }

  .form-container-premium {
    width: 100%;
    max-width: none;
  }

  .form-row-premium {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    width: 100%;
  }

  .input-form-half {
    width: 100% !important;
    flex: 1;
    margin-bottom: 12px !important;
  }

  .input-form-half .form-control {
    min-height: 48px;
    padding: 12px 20px;
    font-size: 15px;
    border-radius: 35px;
    border: 1px solid #aeb1ba;
    transition: all 0.3s ease;
  }

  .input-form-half .form-control:focus {
    border-color: #1e347d;
    box-shadow: 0 0 0 0.2rem rgba(30, 52, 125, 0.15);
    outline: none;
  }

  .input-form-half .label-control {
    font-size: 15px;
    font-weight: 500;
    color: #363739;
    margin-bottom: 8px;
    display: block;
  }

  .btn-premium {
    min-width: 140px !important;
    padding: 12px 30px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    border-radius: 35px !important;
    transition: all 0.3s ease !important;
  }

  .btn-premium:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .form-check {
    margin-bottom: 0;
  }

  .form-check-input {
    width: 18px;
    height: 18px;
    margin-top: 0.125em;
    border-radius: 4px;
    border: 2px solid #aeb1ba;
    transition: all 0.3s ease;
  }

  .form-check-input:checked {
    background-color: #ec621a !important;
    border-color: #ec621a !important;
  }

  .form-check-input:focus {
    border-color: #ec621a;
    box-shadow: 0 0 0 0.2rem rgba(236, 98, 26, 0.15);
  }

  .form-check-label {
    font-size: 15px;
    font-weight: 500;
    color: #363739;
    margin-left: 8px;
  }

  .title-modal {
    text-align: center;
    margin-bottom: 2rem;
  }

  .close-link {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .modal-width-custom {
      max-width: 95% !important;
    }

    .form-row-premium {
      flex-direction: column;
      gap: 0;
    }

    .input-form-half {
      width: 100% !important;
    }

    .btn-premium {
      min-width: 120px !important;
      padding: 10px 25px !important;
    }
  }
</style>
